module.exports = __webpack_public_path__ + "static/img/home_2.b38e337.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_new/home_2.jpg
// module id = NT2L
// module chunks = 6